module.exports = __webpack_public_path__ + "static/media/14.7ed0437b.jpeg";